import {
    HttpResponse,
    UpdateLogModel,
    QueryModel,
    RequestParams,
    UpdateLogModelIEnumerableApiResultSuccess,
    UpdateLogModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class UpdateLogsDataService implements CrudService<UpdateLogModel, UpdateLogModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<UpdateLogModel>): Promise<CrudListResponse<UpdateLogModel>> {
        return ApiService.api.getUpdateLogBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<UpdateLogModel>> {
        return ApiService.api.getUpdateLogById(id, params);
    }

    create(item: UpdateLogModel, params?: RequestParams): Promise<CrudResponse<UpdateLogModel>> {
        return ApiService.api.insertUpdateLog(item, params);
    }

    update(item: UpdateLogModel, params?: RequestParams): Promise<UpdateLogModel> {
        return ApiService.api.updateUpdateLog(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<UpdateLogModel> {
        return ApiService.api.patchUpdateLog(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<UpdateLogModel>): Promise<CrudListResponse<UpdateLogModel>> {
        return ApiService.api.deleteUpdateLog(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<UpdateLogModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
